/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import {
  Button,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup
} from '@chakra-ui/react'
import React from 'react'
import { CiMenuKebab } from 'react-icons/ci'

const VisibilityMenu = ({ table, setColumnVisibility }) => {
  const hideableColumns = table.getAllLeafColumns().filter(
    (column) => column.getCanHide()
  )
  const getVisibleColumns = () => {
    return hideableColumns
      .filter((col) => col.getIsVisible())
      .map((col) => col.id)
  }
  const visibleColumnIds = getVisibleColumns()

  const onChangeValues = (values) => {
    hideableColumns.forEach(column => {
      column.toggleVisibility(values.includes(column.id))
    })
  }

  const clearAll = () => {
    const hiddenColumns = Object
      .fromEntries(
        hideableColumns.map(item => [item.id, false])
      )
    setColumnVisibility(hiddenColumns)
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        colorScheme="gray"
        color="var(--color-headers)"
      >
        <CiMenuKebab className="inline-block" />
      </MenuButton>
      <MenuList minWidth="100px">
        <MenuOptionGroup
          title='Show/Hide Columns'
          type='checkbox'
          value={visibleColumnIds}
          onChange={onChangeValues}
          className="!text-xs"
        >
          { hideableColumns.map((column) => (
            <MenuItemOption
              key={column.id}
              value={column.id}
              className="text-sm"
            >
              { typeof column.columnDef.header === 'string'
                ? column.columnDef.header
                : column.id
              }
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
        <MenuDivider />
        <MenuItemOption
          key={'column.id'}
          value={'column.id'}
          className="text-sm"
          onClick={() => clearAll()}
        >
          Clear all
        </MenuItemOption>
      </MenuList>
    </Menu>
  )
}

export default VisibilityMenu
